import React from 'react';

import GatewayHeader from '../_gateway/GatewayHeader';
import GatewayFooter from '../_gateway/GatewayFooter';
import '../_gateway/gateway.css';

import appBookings from '_assets/images/gateway/passengers/app-bookings.png';
import appDetails from '_assets/images/gateway/passengers/app-details.png';

const IOS_URL = 'https://apps.apple.com/ie/app/prm-assist/id1574371912';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.prmassist';

const FEATURES = [
  {
    title: 'Make PRM assistance bookings globally',
    body: 'Plan ahead by scheduling assistance services at airports around the world.',
    icon: (<svg viewBox="0 0 24 24" width="26" height="26" style={{ color: '#1670c8' }} aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M3 12h18M12 3c2.5 2.5 3.8 6 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-6-3.8-9s1.3-6.5 3.8-9z" fill="none" stroke="currentColor" strokeWidth="1.8" /></svg>),
  },
  {
    title: 'Retrieve and manage your airline assistance requests',
    body: 'Access all your past and upcoming bookings in one easy-to-use dashboard.',
    icon: (<svg viewBox="0 0 24 24" width="26" height="26" style={{ color: '#1670c8' }} aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M9 8h6M9 12h6M9 16h3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>),
  },
  {
    title: 'Communicate directly with airport staff via Support Desk',
    body: 'Get real-time help or updates by messaging support teams instantly.',
    icon: (<svg viewBox="0 0 24 24" width="26" height="26" style={{ color: '#1670c8' }} aria-hidden="true"><path d="M4 5h16v11H9l-4 4V5z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="M8 9h8M8 12h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>),
  },
  {
    title: 'Add personalized notes to tailor your assistance',
    body: 'Share special requirements or preferences to ensure a smooth experience.',
    icon: (<svg viewBox="0 0 24 24" width="26" height="26" style={{ color: '#1670c8' }} aria-hidden="true"><path d="M4 20l1.4-5.4L16.6 3.4a2 2 0 0 1 2.8 0l1.2 1.2a2 2 0 0 1 0 2.8L9.4 18.6 4 20z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="M14.5 5.5l4 4" stroke="currentColor" strokeWidth="1.8" /></svg>),
  },
  {
    title: 'Pre-purchase travel essentials for convenient pickup',
    body: 'Buy mobility aids, comfort items, or travel accessories in advance for airport pickup.',
    icon: (<svg viewBox="0 0 24 24" width="26" height="26" style={{ color: '#1670c8' }} aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="M9 8V6a3 3 0 0 1 6 0v2" fill="none" stroke="currentColor" strokeWidth="1.8" /></svg>),
  },
];

const storeButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  minHeight: 52,
  padding: '14px 24px',
  borderRadius: 12,
  background: '#111111',
  color: '#fff',
  fontSize: 15,
  fontWeight: 600,
  fontFamily: 'var(--gw-font-sans)',
};

const Passengers = () => {
  return (
    <div className="gw-page">
      <GatewayHeader />

      <main id="main">
        <section style={{ maxWidth: 1240, margin: '0 auto', padding: '72px 32px 0' }}>
          <p style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '0 0 16px', fontSize: 12, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: '#1670c8' }}>
            <span aria-hidden="true">→</span> For passengers
          </p>
          <h1 style={{ margin: 0, maxWidth: '16em', fontSize: 'clamp(32px, 4vw, 56px)', lineHeight: 1.02, fontWeight: 800, letterSpacing: '-0.02em', textTransform: 'uppercase', color: '#1c2b4a' }}>
            Everything you need for a smoother journey.
          </h1>
          <p style={{ margin: '22px 0 0', maxWidth: '34em', fontSize: 18, lineHeight: 1.6, color: '#374151', fontFamily: 'var(--gw-font-sans)' }}>
            Request assistance, manage your bookings and stay connected with the support you need — from airport to aircraft — all in one app.
          </p>
        </section>

        <section id="download" aria-label="Download the app" style={{ maxWidth: 1240, margin: '40px auto 0', padding: '0 32px', textAlign: 'center' }}>
          <div style={{ maxWidth: 640, margin: '0 auto', padding: '40px 40px', borderRadius: 28, background: '#f4f8fe', border: '1px solid rgba(32,138,239,0.14)', boxShadow: '0 10px 30px rgba(28,43,74,0.07)' }}>
            <h2 style={{ margin: 0, fontSize: 'clamp(22px, 2.4vw, 28px)', fontWeight: 800, letterSpacing: '-0.02em', textTransform: 'uppercase', color: '#1c2b4a' }}>Download the app</h2>
            <p style={{ margin: '12px 0 0', fontSize: 16, lineHeight: 1.6, color: '#374151', fontFamily: 'var(--gw-font-sans)' }}>Available now on iOS and Android.</p>
            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
              <a href={IOS_URL} target="_blank" rel="noopener noreferrer" style={storeButtonStyle}>
                <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="currentColor" d="M16.365 1.43c0 1.14-.415 2.06-1.246 2.76-.995.838-2.144.99-2.633.95-.03-.1-.086-.916.415-1.79.5-.87 1.5-1.53 2.4-1.85.42-.16.856-.24 1.064-.07zM20.02 17.35c-.36.83-.79 1.6-1.29 2.31-.68.98-1.24 1.66-1.68 2.04-.68.6-1.41.91-2.19.92-.56 0-1.23-.16-2.01-.49-.78-.32-1.5-.48-2.14-.48-.68 0-1.42.16-2.22.48-.8.33-1.44.5-1.94.51-.75.03-1.5-.29-2.24-.95-.47-.42-1.07-1.13-1.79-2.14-.78-1.08-1.42-2.33-1.92-3.75-.54-1.53-.81-3.01-.81-4.44 0-1.64.35-3.05 1.06-4.24.55-.95 1.29-1.71 2.2-2.26.92-.55 1.9-.83 2.97-.85.6 0 1.38.19 2.36.55.97.37 1.6.55 1.87.55.2 0 .9-.21 2.1-.63 1.13-.4 2.09-.56 2.87-.5 2.13.17 3.72 1.01 4.79 2.53-1.9 1.15-2.85 2.77-2.83 4.84.02 1.62.6 2.97 1.75 4.05.52.5 1.1.88 1.75 1.16-.14.4-.29.79-.46 1.15z" /></svg>
                Download on iOS
              </a>
              <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer" style={storeButtonStyle}>
                <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="currentColor" d="M3.6 2.6c-.3.3-.5.7-.5 1.2v16.4c0 .5.2.9.5 1.2l.1.1L13 12.2v-.4L3.7 2.5l-.1.1z" /><path fill="currentColor" d="M16.2 15.4l-3.2-3.2v-.4l3.2-3.2 3.6 2.05c.7.4.7 1.3 0 1.7l-3.6 2.05z" /><path fill="currentColor" d="M13 12.2L3.7 21.5c.35.35.9.4 1.32.15l10.85-6.2-2.87-3.25z" /><path fill="currentColor" d="M13 11.8l2.87-3.25-10.85-6.2c-.42-.25-.97-.2-1.32.15L13 11.8z" /></svg>
                Download on Android
              </a>
            </div>
          </div>
        </section>

        <section aria-label="App features" style={{ maxWidth: 1240, margin: '56px auto 0', padding: '0 32px', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 64, alignItems: 'start' }}>
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 34 }}>
            {FEATURES.map((f) => (
              <li key={f.title} style={{ display: 'flex', gap: 18 }}>
                <span aria-hidden="true" style={{ flex: '0 0 auto', width: 52, height: 52, display: 'grid', placeItems: 'center', borderRadius: 14, background: '#eaf2fd' }}>
                  {f.icon}
                </span>
                <div>
                  <h3 style={{ margin: 0, fontSize: 21, fontWeight: 800, letterSpacing: '-0.01em', color: '#1c2b4a' }}>{f.title}</h3>
                  <p style={{ margin: '8px 0 0', fontSize: 16, lineHeight: 1.6, color: '#6b7280', fontFamily: 'var(--gw-font-sans)' }}>{f.body}</p>
                </div>
              </li>
            ))}
          </ul>

          <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: 4, padding: '12px 0 40px' }}>
            <img
              src={appBookings}
              alt="PRM Assist app — Upcoming bookings list, showing scheduled assistance requests with airport, flight and reference details."
              style={{ width: '46%', maxWidth: 230, height: 'auto', display: 'block', filter: 'drop-shadow(0 20px 40px rgba(28,43,74,0.16))' }}
            />
            <img
              src={appDetails}
              alt="PRM Assist app — Booking details screen with Trip Review, Flight Information, PRM Information, Support Desk, digital sunflower lanyard, expected arrival time and delete booking options."
              style={{ width: '46%', maxWidth: 230, height: 'auto', display: 'block', marginTop: 36, filter: 'drop-shadow(0 20px 40px rgba(28,43,74,0.16))' }}
            />
          </div>
        </section>
      </main>

      <GatewayFooter />
    </div>
  );
};

export default Passengers;
